import { authTypes } from '../actions/_auth_actions';

export default (state = {}, action) => {
  switch (action.type) {
    case authTypes.LOGIN:
      return {
        uid: action.uid,
        claim: action.claim,
        isAbleTo: action.isAbleTo,
        userData: action.userData,
      };
    case authTypes.ADMINSIGNOUT:
      return {};
    case authTypes.ADMINSESSION:
      return {
        claim: action.claim,
        uid: action.uid,
        userData: action.userData,
      };
    default:
      return state;
  }
};
